import React from 'react';
import { Box } from '@chakra-ui/react';
import SignUpForm from '../../components/signUpForm';

export const SignUpPage = () => {
  return (
    <Box width="416px" maxWidth="100%" margin="auto" height="100%">
      <SignUpForm />
    </Box>
  );
};
